import React, { Fragment, useState } from 'react';
import { Button, Form, FloatingLabel, Row, Col, Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const FormBusca = (props) => {
    const [nome, setNome] = useState("");
    // A cada mudança → aplicar filtro local
    const handleNomeChange = (e) => {
        const value = e.target.value;
        setNome(value);
        props.filtrarLocalmente(value);
    };

    const limpar = () => {
        setNome("");
        props.fetchUsers(); // restaura lista original
    };

    return (
        <Fragment>
            <Container className="da-espaco">

                <Row xs={1} lg={3}>

                    <Col>
                        <FloatingLabel label="Nome" className="mb-3">
                            <Form.Control
                                type="text"
                                value={nome}
                                onChange={handleNomeChange}
                            />
                        </FloatingLabel>
                    </Col>
                    <Col xs={6} lg={2}>
                        <Button
                            type="button"
                            variant="danger"
                            className="botao-alto"
                            onClick={limpar}
                        >
                            Limpar Busca
                        </Button>
                    </Col>
                    <Col xs={6} lg={2}>
                        <Link to={'/ti/user'}>
                            <Button variant="danger" className="botao-alto" type="button">
                                Voltar
                            </Button>
                        </Link>
                    </Col>
                </Row>
            </Container>
        </Fragment>
    );
};

export default FormBusca;